<template>
    <div>
        <v-card>

            <v-card-title class="btn_otro">
                <v-row class="d-flex justify-space-between py-0 pl-4">
                    {{this.datos.id ? 'EDITAR ' : 'CREAR '}} SECUENCIA DIDÁCTICA
                    <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
                </v-row>
            </v-card-title>

            <v-card-text> 
                <v-form ref="formDatos" lazy-validation>
                    <v-row class="py-0">
                        <v-col cols="12" lg="3">
                            <v-select
                                :items="listSecuencias"
                                item-text="nombre"
                                item-value="id"
                                persistent-hint
                                single-line
                                :rules="[rul.required]" 
                                v-model="datos.id_secuencia"
                            >
                            </v-select>
                        </v-col>
                        <v-col cols="12" lg="9">
                            <v-text-field label="Nombre de la diapositiva" :rules="[rul.required]" 
                            v-model="datos.nombre"></v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-row>
                        <v-col cols="12">
                            <v-card class="mb-5"  v-for="(proceso, indexProceso) in datos.procesosPedagogicos" :key="indexProceso">
                                <v-card-text>
                                    <v-row class="py-0 my-0">
                                        <v-col cols="10" class="py-0 my-0">
                                            <v-text-field :label="'Proceso pedagógico ' + (indexProceso + 1)" v-model="proceso.nombre"></v-text-field>
                                        </v-col>
                                        <v-col cols="2" class="py-0 my-0">
                                            <v-btn class="btn_agregar py-0" fab x-small
                                            v-if="indexProceso == datos.procesosPedagogicos.length - 1" 
                                            @click="addProceso()"
                                            :disabled="proceso.nombre.length == 0"
                                            >
                                                <v-icon>fa-plus</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="10" class="py-0 my-0">
                                            <v-text-field label="Tiempo" 
                                            type="number" hint="Tiempo en minutos"
                                            v-model="proceso.tiempo"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="py-0 my-0" v-for="(actividad, indexActividad) in proceso.actividades" :key="'P'+indexProceso+'A'+indexActividad">
                                        <v-col class="py-0 my-0">
                                            <v-text-field :label="'Actividad ' + (indexActividad + 1) " v-model="actividad.nombre"></v-text-field>
                                        </v-col>
                                        <v-col cols="2" class="py-0 my-0">
                                            <v-btn class="btn_agregar py-0" fab x-small 
                                            v-if="indexActividad == proceso.actividades.length - 1" 
                                            @click="addActividad(indexProceso)"
                                            :disabled="actividad.nombre.length == 0"
                                            >
                                                <v-icon>fa-plus</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row class="py-0 my-0" v-for="(recurso, indexRecurso) in proceso.recursos" :key="'P'+indexProceso+'R'+indexRecurso">
                                        <v-col class="py-0 my-0">
                                            <v-text-field :label="'Recurso ' + (indexRecurso + 1) " v-model="recurso.nombre"></v-text-field>
                                        </v-col>
                                        <v-col cols="2" class="py-0 my-0">
                                            <v-btn class="btn_agregar py-0" fab x-small 
                                            v-if="indexRecurso == proceso.recursos.length - 1"
                                            @click="addRecurso(indexProceso)"
                                            :disabled="recurso.nombre.length == 0"
                                            >
                                                <v-icon>fa-plus</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-textarea rows="1" label="Referencias Bibliográficas" v-model="datos.referencias"></v-textarea>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer> 
                <v-btn class="primary" @click="saveSecuenciaDidactica">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
    import axios from '@/helpers/axios'
    import { mapMutations, mapGetters, mapActions} from 'vuex'

    export default {
        name:'secuenciaDidactica',
        props:{
            datos: {
                type: Object,
                default: Object
            },
        },
        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente:{ 'id_submodulo':141, "id_modulo": 5}, //sud_modulo y modulo

            datoLogin: sessionStorage, // variables de sesion del usuario
            ////////////////////////////////////////////////////////

            //validaciones de formulario
            rul: {
                required: value => !!value || 'Campo Requerido',
                inputReq: value => !!value || 'Campo Requerido',
                selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
                email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo es incorrecto',
                min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
                min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
                min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
                max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
                max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
                max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
                max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
                max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
                max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
                max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
                max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
                max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',
            },

            props:{
                datos: {
                    type: Object,
                    default: Object
                }
            },

            listSecuencias: [],
            
            // modal confirmacion
            name_confirm:'',
            id_delete:null,
            dialog_confirm:false,
            desc_confirm: '',
            eventoConfirm: '',
            //////////////////////////////////
        }),

        computed: {
            ...mapGetters('login', [ 'componenteEvento']),
        },

        mounted (){
        },

        created () {
            this.actualizarParamentro();
            this.getSecuencias();
        },

        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
             //----- Validar accesos por perfil ------------
            ...mapActions('login',['parametroComponente'] ),

            actualizarParamentro() {
                this.parametroComponente(this.paramComponente)
            },

            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////

            ////////  METODO QUE LIMPIA EL FORMULARIO Y VARIABLES /////////
            async limpiarForm(){
                this.editedItem = {
                    id:0, id_colegio: this.datoLogin.id_colegio,
                    id_admision: "", grados: [], idsGrados: [], id_usuario: this.datoLogin.id
                };
                this.$refs.formDatos.resetValidation();
            },

            async saveSecuenciaDidactica(){
                if (this.$refs.formDatos.validate()) {
                    try {
                        let res = {}
                        this.datos.id_usuario =  this.datoLogin.id
                        const params = {
                            id_colegio: this.datoLogin.id_colegio, id_secuencia: this.datos.id_secuencia,
                            nombre: this.datos.nombre, referencias: this.datos.referencias, id_usuario: this.datos.id_usuario,
                            procesosPedagogicos: this.datos.procesosPedagogicos
                        }   
                                        
                        if (this.datos.id) {
                            res = await axios.put(`/manager/sesionAprendizaje/secuencia/${this.datos.id}/`, params);                        
                        } else {                        
                            res = await axios.post(`/manager/sesionAprendizaje/${this.datos.id_sesion_aprendizaje}/secuencia/`, params);                                                  
                        }

                        this.setEnviarMens({ tipo: res.data.messageT, mensaje: res.data.message, tiempo: 6000});
                        console.log(this.datos, res);
                        if(res.data.messageT == "S"){
                            console.log('Secuencia didáctica: ', res.data);  
                            this.$emit('post-save');                   
                        }

                    } catch (error) {
                        //console.log(handleError(error))
                        console.log(error);
                        this.setEnviarMens({ tipo: "E", mensaje: `Error al guardar registro`, tiempo: null })
                    }
                }
            },

            async getSecuencias() {
                try{
                    let resp   = await axios.get(`/manager/sesionAprendizaje/secuencias/`);
                    this.listSecuencias = resp.data;
                } catch(error){
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }
            },

            addActividad(indexProceso){
                this.datos.procesosPedagogicos[indexProceso].actividades.push({nombre: ""})
            },

            addRecurso(indexProceso){
                this.datos.procesosPedagogicos[indexProceso].recursos.push({nombre: ""})
            },

            addProceso(){
                this.datos.procesosPedagogicos.push({nombre: "", tiempo: 1, actividades: [{nombre: ""}], recursos: [{nombre: ""}]})
            }
        }
    }
</script>
